import { createContext, useContext, useEffect, useMemo, useState } from "react";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

const STORAGE_KEY = "kc_wishlist_v1";

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const has = (slug) => items.some((i) => i.slug === slug);

  const toggle = (product) => {
    setItems((prev) =>
      prev.some((i) => i.slug === product.slug)
        ? prev.filter((i) => i.slug !== product.slug)
        : [
            {
              slug: product.slug,
              title: product.title,
              price: product.price,
              compare_at: product.compare_at,
              discount_pct: product.discount_pct,
              images: product.images,
              sizes: product.sizes,
              variants: product.variants,
              default_variant_id: product.default_variant_id,
              badge: product.badge,
              reviews_count: product.reviews_count,
            },
            ...prev,
          ]
    );
  };

  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));

  const value = useMemo(() => ({ items, count: items.length, has, toggle, remove }), [items]);
  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
};
